import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumb from "@/components/base/Breadcrumb";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { allCategories } from "@/utils/software";
import { toneIconWrap } from "@/utils/ui";

const values = [
  {
    icon: "ri-focus-3-line",
    title: "专注黄金领域",
    desc: "只做黄金投资相关软件与工具，内容更垂直、更聚焦。",
  },
  {
    icon: "ri-shield-check-line",
    title: "信息清晰透明",
    desc: "标注软件分类、版本、平台与更新时间，帮助你理性选择。",
  },
  {
    icon: "ri-refresh-line",
    title: "内容持续更新",
    desc: "跟踪软件版本迭代与市场变化，保持信息时效性。",
  },
  {
    icon: "ri-user-heart-line",
    title: "面向真实用户",
    desc: "为散户投资者与理财用户设计，实用优先，无冗余干扰。",
  },
];

export default function About() {
  useDocumentMeta({
    title: "关于我们 - 黄金网站软件app免费",
    description:
      "了解黄金网站软件app免费的网站定位、主营内容与联系方式。我们专注黄金投资软件推荐与免费下载，帮助投资者高效掌握黄金资讯与实用工具。",
    keywords: "关于黄金网站软件app免费,黄金投资软件站,黄金软件下载平台",
  });

  return (
    <SiteLayout>
      <section className="bg-secondary-950">
        <div className="container-page py-14 md:py-20">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          <h1 className="mt-6 font-heading text-3xl font-bold text-background-50 md:text-4xl">
            关于黄金网站软件app免费
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-background-300 md:text-base">
            我们是一个面向黄金投资者的软件与应用推荐下载站，专注收集、整理并推荐实用的黄金投资工具，帮助用户快速找到契合自身需求的行情分析、价格监控、理财与资讯软件。
          </p>
        </div>
      </section>

      <section className="container-page py-12">
        <div className="grid gap-8 lg:grid-cols-[1.15fr_1fr]">
          <div className="flex flex-col gap-4">
            <span className="chip w-fit bg-primary-100 text-primary-800">
              <i className="ri-compass-3-line" />
              网站定位
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-950">
              为黄金投资者提供实用的工具导航
            </h2>
            <p className="text-sm leading-relaxed text-foreground-700">
              随着黄金投资热度上升，各类软件层出不穷，选择成本也在提高。黄金网站软件app免费希望成为你身边的黄金工具向导：按功能分类整理软件，提供清晰的软件介绍与规格说明，让散户投资者和理财经常用户在几分钟内完成从了解到下载的全过程。
            </p>
            <p className="text-sm leading-relaxed text-foreground-700">
              我们不追逐噱头，只关注软件是否真正实用、信息是否准确透明。所有软件均以演示资源形式呈现，方便你了解行业常见工具形态，再决定是否前往官方渠道获取正式版本。
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {values.map((item) => (
              <div key={item.title} className="card-surface flex flex-col gap-2 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-2xl text-primary-700">
                  <i className={item.icon} />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900">
                  {item.title}
                </h3>
                <p className="text-xs leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-y border-background-200 bg-background-100">
        <div className="container-page py-12">
          <h2 className="font-heading text-2xl font-bold text-foreground-950">主营内容</h2>
          <p className="mt-2 max-w-3xl text-sm text-foreground-600">
            围绕黄金投资场景，我们把软件划分为以下四大类，便于快速查找。
          </p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {allCategories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className="card-surface group flex flex-col gap-3 p-5 transition-colors hover:border-primary-400"
              >
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-lg text-2xl ${
                    toneIconWrap[cat.tone] ?? toneIconWrap.primary
                  }`}
                >
                  <i className={cat.icon} />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-700">
                  {cat.name}
                </h3>
                <p className="line-clamp-3 text-xs leading-relaxed text-foreground-600">
                  {cat.desc}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="container-page py-12">
        <div className="grid gap-8 lg:grid-cols-2">
          <div className="flex flex-col gap-4">
            <h2 className="font-heading text-2xl font-bold text-foreground-950">联系我们</h2>
            <p className="text-sm leading-relaxed text-foreground-600">
              如有软件收录建议、信息纠错或合作意向，欢迎通过以下方式与我们取得联系。
            </p>
            <ul className="flex flex-col gap-3">
              <li className="card-surface flex items-center gap-3 p-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/15 text-xl text-primary-700">
                  <i className="ri-mail-line" />
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">邮箱</p>
                  <p className="text-sm text-foreground-600">service@huangjinruanjianapp.com</p>
                </div>
              </li>
              <li className="card-surface flex items-center gap-3 p-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/15 text-xl text-primary-700">
                  <i className="ri-wechat-line" />
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">微信公众号</p>
                  <p className="text-sm text-foreground-600">黄金软件导航</p>
                </div>
              </li>
              <li className="card-surface flex items-center gap-3 p-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/15 text-xl text-primary-700">
                  <i className="ri-time-line" />
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">服务时间</p>
                  <p className="text-sm text-foreground-600">周一至周五 9:00 - 18:00</p>
                </div>
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <h2 className="font-heading text-2xl font-bold text-foreground-950">免责说明与版权</h2>
            <div className="card-surface flex flex-col gap-3 p-5 text-sm leading-relaxed text-foreground-600">
              <p>
                本站所有软件信息、截图与下载链接均为演示用途，展示的是常见黄金投资工具的功能形态，不构成任何投资建议。
              </p>
              <p>
                本站不提供真实软件下载，用户如需正式软件，请前往软件官方渠道获取。任何依据本站信息作出的投资决策，风险由投资者自行承担。
              </p>
              <p>
                本站原创的整理内容版权归本站所有，转载请联系授权；涉及的软件名称、商标与截图版权归各自权利人所有。
              </p>
              <p className="text-foreground-500">© 2026 黄金网站软件app免费 · 保留所有权利</p>
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}